<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header">
  
  <h3 class="modal-title">Update Division</h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <div>Select the Division that you want:</div>
  <div class="row mt-3">
    <div class="col-lg-6">
      <form class="form-inline d-flex md-form form-sm">
        <input class="form-control form-control-sm mr-3 w-75" (keyup)="onEnterKeySearchJurisdiction($event)"
          [(ngModel)]="searchText" type="text" placeholder="Search" name="search" aria-label="Search" />
        <i class="fa fa-search cursor-pointer" (click)="searchJurisdiction()" aria-hidden="true"></i>
      </form>
    </div>
    <div class="col-lg-6" *ngIf="commonService.checkPlanTypeAction('SSAJ')">
      <form class="form-inline d-flex md-form form-sm">
        <input class="form-control form-control-sm mr-3 w-75" (keyup)="onKeyUp($event)" [(ngModel)]="jurisdictionObj.title"
          type="text" placeholder="Add new division" name="Add New" aria-label="Add New" />
        <i class="fa fa-plus-circle search-icon cursor-pointer" (click)="addJurisdiction()" aria-hidden="true"></i>
        <i *ngIf="isLoader" class="fa fa-circle-o-notch fa-spin" style="font-size: .875rem; line-height: 1.5;"></i>
        <div class="fg-g-red" *ngIf="isDisabled">{{disabledText}}</div>
      </form>
    </div>
  </div>
  <div class="overflow-x mt-3" style="width: 100%;">
    <table class="table table-curved table-striped table-hover table-bordered">
      <thead class="box-shadow-none">
        <tr>
          <th>Division</th>
          <th class="text-center">
            <input type="checkbox" name="All" *ngIf="!isJuriSelectAll" (change)="selectAllJurisdiction($event)" />
            <input type="checkbox" name="All" checked *ngIf="isJuriSelectAll"
              (change)="selectAllJurisdiction($event)" />
          </th>
        </tr>
      </thead>
      <tbody class="table-body">
        <ng-container *ngFor="let item of jurisdictionList">
          <tr>
            <th>{{item.title}}</th>
            <th class="text-center">
              <input type="checkbox" (change)="updateJurisdiction(item.id, $event)"
                [value]="checkUserJurisdiction(item.id)" [attr.checked]="checkUserJurisdiction(item.id) ? '' : null" />
            </th>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-sm bg-g-red" [mat-dialog-close]="">Cancel</button>
  <button class="btn btn-sm bg-g-lightGreen" (click)="saveJurisdiction()" cdkFocusInitial>Update</button>
</div>
